import { render, staticRenderFns } from "./Markers.vue?vue&type=template&id=2b3c7b3e&scoped=true&lang=pug&"
import script from "./Markers.vue?vue&type=script&lang=js&"
export * from "./Markers.vue?vue&type=script&lang=js&"
import style0 from "./Markers.vue?vue&type=style&index=0&id=2b3c7b3e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3c7b3e",
  null
  
)

/* custom blocks */
import block0 from "./Markers.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports